"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "schedules.closedSlot";
  var componentName = "closedSlot";

  var bindings = {
    resolve: "<?",
    _id: "<?"
  };

  var templateUrl = "app/pages/schedules/closedSlot/closedSlot.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $rootScope, $window, $timeout, UsersService, DepasService, OperatorsService, FormlyService, CustomListsService, ModalService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.$timeout = $timeout;
      this.UsersService = UsersService;
      this.DepasService = DepasService;
      this.ModalService = ModalService;
      this.CustomListsService = CustomListsService;
      this.FormlyService = FormlyService;
      this.OperatorsService = OperatorsService;
    }

    _createClass(Controller, [{
      key: "close",
      value: function close() {
        console.log("$scope", this.$scope);
        if (this.$scope.$parent) {
          this.$scope.$parent.$dismiss();
        }
        Notiflix.Loading.remove();
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var closedSlotId, closedSlot;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                  _context.next = 3;
                  return this.OperatorsService.getSelectArray();

                case 3:
                  this.operators = _context.sent;
                  closedSlotId = this.resolve.params._id;
                  closedSlot = void 0;

                  if (!closedSlotId) {
                    _context.next = 10;
                    break;
                  }

                  _context.next = 9;
                  return this.DepasService.findById({
                    _id: closedSlotId.replace("$", "")
                  });

                case 9:
                  closedSlot = _context.sent;

                case 10:

                  if (closedSlot && closedSlot.slot) {
                    this.model = {
                      operatorId: closedSlot.slot.operatorId,
                      startDate: moment(closedSlot.slot.start).format("YYYY-MM-DD"),
                      startTime: moment(closedSlot.slot.start).format("HH:mm"),
                      endDate: moment(closedSlot.slot.end).format("YYYY-MM-DD"),
                      endTime: moment(closedSlot.slot.end).format("HH:mm"),
                      note: closedSlot.note
                    };
                  } else {
                    this.model = {
                      operatorId: null,
                      startDate: null,
                      startTime: "7:00",
                      endDate: null,
                      endTime: "20:00",
                      note: null
                    };
                  }

                  _context.next = 13;
                  return this.createFields();

                case 13:

                  this.$timeout(function () {}, 10);
                  Notiflix.Loading.remove();

                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()
    }, {
      key: "createFields",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this = this;

          var fields, operator, operatorName;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  fields = [this.FormlyService.date("startDate", "Date de début", true, {
                    className: "col-xs-12 col-sm-6 col-md-6"
                  }), this.FormlyService.time("startTime", "Heure de début", true, {
                    className: "col-xs-12 col-sm-6 col-md-6"
                  }), this.FormlyService.date("endDate", "Date de fin", true, {
                    className: "col-xs-12 col-sm-6 col-md-6"
                  }), this.FormlyService.time("endTime", "Heure de fin", true, {
                    className: "col-xs-12 col-sm-6 col-md-6"
                  }), this.FormlyService.text("note", "Description", true, {
                    className: "col-xs-12 col-sm-12 col-md-12"
                  })];


                  if (this.resolve.params._id) {
                    operator = this.operators.find(function (item) {
                      return item.value === _this.model.operatorId;
                    });
                    operatorName = operator ? operator.name : "?.?";

                    this.displayTitle = "Modification d'une p\xE9riode ferm\xE9e pour " + operatorName;
                  } else {
                    this.displayTitle = "Création d'une période fermée";
                    fields.unshift(this.FormlyService.list("operatorId", "Conseiller/ère", [{ name: "Tous les conseillers/ères", value: "all" }].concat(_toConsumableArray(this.operators)), true, {
                      className: "col-xs-12 col-sm-12 col-md-12"
                    }));
                  }

                  this.rows = [{
                    columns: [{
                      class: "col-xs-12 col-sm-12 col-md-12",
                      boxes: [{
                        mainTitle: "Informations",
                        fields: [].concat(fields)
                      }]
                    }]
                  }];

                  this.$timeout(function () {}, 0);

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function createFields() {
          return _ref2.apply(this, arguments);
        }

        return createFields;
      }()
    }, {
      key: "save",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var save, start, end, startTime, endTime, operators, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, operatorId, depaParams, response, _response;

          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  save = true;


                  if (!this.model.operatorId) {
                    Notiflix.Notify.failure("Le nom du conseiller ou de la conseillère est obligatoire !");
                    save = false;
                  }
                  if (!this.model.startDate) {
                    Notiflix.Notify.failure("La date de début est obligatoire !");
                    save = false;
                  }
                  if (!this.model.startTime) {
                    Notiflix.Notify.failure("L'heure de début est obligatoire !");
                    save = false;
                  }
                  if (!this.model.endDate) {
                    Notiflix.Notify.failure("La date de fin est obligatoire !");
                    save = false;
                  }
                  if (!this.model.endTime) {
                    Notiflix.Notify.failure("L'heure de fin est obligatoire !");
                    save = false;
                  }
                  if (!this.model.note) {
                    Notiflix.Notify.failure("La description est obligatoire !");
                    save = false;
                  }

                  start = void 0;
                  end = void 0;

                  if (this.model.startDate && this.model.startTime && this.model.endDate && this.model.endTime) {
                    start = moment(this.model.startDate);
                    startTime = this.model.startTime.split(":");

                    start = start.set({
                      hour: startTime[0],
                      minute: startTime[1],
                      second: 0
                    });
                    end = moment(this.model.endDate);
                    endTime = this.model.endTime.split(":");

                    end = end.set({
                      hour: endTime[0],
                      minute: endTime[1],
                      second: 0
                    });

                    if (end.diff(start) <= 0) {
                      Notiflix.Notify.failure("Le début de la période doit être strictement supérieur à la fin de la période !");
                      save = false;
                    }
                  }

                  operators = [];

                  if (this.model.operatorId !== "all") {
                    operators = [this.model.operatorId];
                  } else {
                    operators = this.operators.map(function (item) {
                      return item.value;
                    });
                  }

                  if (!(save === true)) {
                    _context3.next = 61;
                    break;
                  }

                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context3.prev = 17;
                  _iterator = operators[Symbol.iterator]();

                case 19:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context3.next = 45;
                    break;
                  }

                  operatorId = _step.value;

                  // create Depa:
                  depaParams = {
                    customerId: this.$rootScope.$selectedCustomerId,
                    status: "Fermé",
                    slot: {
                      operatorId: operatorId,
                      start: start.toDate(),
                      end: end.toDate()
                    },
                    note: this.model.note
                  };

                  if (!(this.resolve.params._id && this.model.operatorId !== "all")) {
                    _context3.next = 34;
                    break;
                  }

                  depaParams.informOperator = this.model.informOperator;

                  _context3.next = 26;
                  return this.DepasService.updateAttributesById(this.resolve.params._id.replace("$", ""), depaParams);

                case 26:
                  response = _context3.sent;

                  if (response._id) {
                    _context3.next = 32;
                    break;
                  }

                  Notiflix.Loading.remove();
                  _context3.next = 31;
                  return swal("", "Une erreur est survenue lors de la sauvegarde.", "error");

                case 31:
                  return _context3.abrupt("return");

                case 32:
                  _context3.next = 42;
                  break;

                case 34:
                  _context3.next = 36;
                  return this.DepasService.customPost("createOneClosedSlot", depaParams);

                case 36:
                  _response = _context3.sent;

                  if (!(!_response || !_response.length || !_response[0]._id)) {
                    _context3.next = 42;
                    break;
                  }

                  Notiflix.Loading.remove();
                  _context3.next = 41;
                  return swal("", "Une erreur est survenue lors de la sauvegarde.", "error");

                case 41:
                  return _context3.abrupt("return");

                case 42:
                  _iteratorNormalCompletion = true;
                  _context3.next = 19;
                  break;

                case 45:
                  _context3.next = 51;
                  break;

                case 47:
                  _context3.prev = 47;
                  _context3.t0 = _context3["catch"](17);
                  _didIteratorError = true;
                  _iteratorError = _context3.t0;

                case 51:
                  _context3.prev = 51;
                  _context3.prev = 52;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 54:
                  _context3.prev = 54;

                  if (!_didIteratorError) {
                    _context3.next = 57;
                    break;
                  }

                  throw _iteratorError;

                case 57:
                  return _context3.finish(54);

                case 58:
                  return _context3.finish(51);

                case 59:
                  Notiflix.Loading.remove();
                  if (this.$scope.$parent) {
                    this.$scope.$parent.$close();
                  }

                case 61:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[17, 47, 51, 59], [52,, 54, 58]]);
        }));

        function save() {
          return _ref3.apply(this, arguments);
        }

        return save;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();